'use client';

import { useContext, useState } from 'react';
import styles from './login.module.scss';
import Image from 'next/image';
import loginImage from 'assets/images/imageLogin.jpg';
import { GlobalContext } from 'context';
import { Form, Input, Button, message, Divider, Select, Space } from 'antd';
import { AppLinkComp } from 'components';
import { AppStorage, RestAPI, ToEnglish, useAsyncClick } from 'scripts';
import { __RegisterType } from './login.type';
import { API, PATH } from 'data';
import { JWTTokenType } from 'types';
import { useSearchParams } from 'next/navigation';
import { __PhoneData } from 'tehranto/signupOTP/firstStep/firstStep.data';
function LoginComp() {
  const langText = useContext(GlobalContext).langText;
  const lang = langText.login;
  const [loginForm] = Form.useForm<__RegisterType>();
  const params = useSearchParams();
  const [search, setSearch] = useState('');
  const noCodeAccess = !!Number(process.env.NEXT_PUBLIC_DISABLE_CODE_REGISTRATION);
  const onChangeForm = () => {
    const values = loginForm.getFieldsValue();
    loginForm.setFields(Object.keys(values).map(i => ({
      name: i,
      errors: undefined
    })));
  };
  const submitHandler = (value: __RegisterType) => {
    return new Promise(resolve => {
      const phoneValue = loginForm.getFieldsValue();
      const phone = `${noCodeAccess ? '' : phoneValue.prefix.split('|')[0]}${ToEnglish(phoneValue.phone)}`;
      RestAPI.post<JWTTokenType>(API.middlewares.login, {
        phone,
        password: value.password
      }).then(res => {
        AppStorage.authToken.set(res.data);
        window.location.href = params.get('redirect') ?? PATH(langText.lang).panel.index;
      }).catch(() => {
        message.error(lang.codeSubmitError);
        resolve(true);
      });
    });
  };
  const handler = useAsyncClick(submitHandler);
  return <div className={`${styles['container']} main-content justify-content-between center-content-y gap-24 pt-5 pb-10 flex-1`} data-sentry-component="LoginComp" data-sentry-source-file="login.index.tsx">
            <div className={`${styles['form-layout']}`}>
                <div>
                    <h2 className="t-900 t-h3 t-md-h2">{lang.login_title}</h2>
                    <p className="mt-2 t-p2 t-400 mb-3">{lang.login_desc}</p>
                    <Form<__RegisterType> layout="vertical" form={loginForm} onFinish={handler.onClick} onChange={onChangeForm} name="phone" data-sentry-element="Form" data-sentry-source-file="login.index.tsx">
                        <Form.Item<__RegisterType> name="phone" label={lang.phone_title} validateTrigger={false} rules={[{
            required: true,
            message: lang.phoneRequired
          }]} data-sentry-element="unknown" data-sentry-source-file="login.index.tsx">
                            <Input autoComplete="nope" addonBefore={<Form.Item<__RegisterType> name="prefix" noStyle rules={[{
              required: true
            }]} initialValue={__PhoneData.find(i => i.desc === 'Canada')?.value}>
                                        <Select popupMatchSelectWidth={false} optionLabelProp="newLabel" options={__PhoneData.filter(i => i.value === 'divider' ? 1 : search.length ? ToEnglish(i.label).includes(search) || i.desc.toLowerCase().includes(search.toLowerCase()) : 1)} dropdownRender={menu => <>
                                                    <Space.Compact className="p-1" style={{
                  maxWidth: 275
                }}>
                                                        <Input onChange={s => setSearch(s.target.value)} allowClear placeholder={lang.search} />
                                                    </Space.Compact>
                                                    <Divider style={{
                  margin: '8px 0'
                }} />
                                                    {menu}
                                                </>} optionRender={option => option.data.short !== 'divider' ? <Space>
                                                        <span role="img" style={{
                  fontFamily: 'Twemoji Country Flags'
                }} aria-label={option.data.label}>
                                                            {option.data.emoji}
                                                        </span>
                                                        {option.data.desc.substring(0, 25) + (option.data.desc.length > 25 ? '...' : '')}
                                                    </Space> : <Divider className="m-0-i" />} />
                                    </Form.Item>} className={`${styles['input-phone']} w-100`} data-sentry-element="Input" data-sentry-source-file="login.index.tsx" />
                        </Form.Item>
                        <Form.Item<__RegisterType> name="password" label={lang.password_title} validateTrigger={false} rules={[{
            required: true,
            message: lang.passwordRequired
          }]} data-sentry-element="unknown" data-sentry-source-file="login.index.tsx">
                            <Input.Password autoComplete="new-password" type="password" data-sentry-element="unknown" data-sentry-source-file="login.index.tsx" />
                        </Form.Item>
                        <p>
                            {lang.noAccount}{' '}
                            <AppLinkComp href={PATH(langText.lang).signup(params.get('redirect') ?? undefined)} className="t-primary" data-sentry-element="AppLinkComp" data-sentry-source-file="login.index.tsx">
                                {lang.signup}
                            </AppLinkComp>
                        </p>
                        <Form.Item className="m-0-i" data-sentry-element="unknown" data-sentry-source-file="login.index.tsx">
                            <Button loading={handler.loading} htmlType="submit" className={`w-100 mt-5`} data-sentry-element="Button" data-sentry-source-file="login.index.tsx">
                                {lang.login_account}
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className={`${styles['image-layout']} d-pre-md-none`}>
                <Image src={loginImage} alt="login image" width={645} height={539} className="w-100" data-sentry-element="Image" data-sentry-source-file="login.index.tsx" />
            </div>
        </div>;
}
export default LoginComp;